// extracted by mini-css-extract-plugin
export default {"minheight":"Home_minheight__+U0gz","navBg":"Home_navBg__4oVAr","logo":"Home_logo__GVdEU","font":"Home_font__ic4Rh","footerBg":"Home_footerBg__u99sq"};